module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ls-clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "ls-actions-btn"
  }, [_c('div', {
    staticClass: "ls-float-right"
  }, [_c('authorized-link', {
    attrs: {
      "tag": "update_setting"
    }
  }, [_c('a', {
    staticClass: "ls-btn router-link-active",
    attrs: {
      "href": "/",
      "title": "Cancelar"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.cancel')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "ls-btn ls-btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.save')))])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58cfff6e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/settings/components/ButtonSubmit.vue
// module id = 783
// module chunks = 1